<template>
  <div>
    <template v-if="readOnly">
      <div v-if="selectedIds.length" class="d-flex flex-wrap" style="gap: 7px;">
        <v-chip v-for="id in displayIds" :key="id" small outlined>
          <v-icon small left color="primary">mdi-pine-tree</v-icon>{{ habitatName(id) }}
        </v-chip>
      </div>
      <div v-else class="text-caption font-italic grey--text text--darken-1">{{ $t('noHabitatSelected') }}</div>
    </template>

    <v-autocomplete
    v-else
    v-model="selectedIds"
    :items="habitats"
    item-value="mitigationHabitatId"
    item-text="name"
    :label="$t('selectHabitats')"
    :filter="filterHabitat"
    :no-data-text="$t('noMatchingHabitats')"
    :menu-props="{ maxWidth: menuWidth, maxHeight: 150 }"
    multiple
    chips
    small-chips
    deletable-chips
    clearable
    autocomplete="chrome-off"
    color="black"
    item-color="primary"
    outlined
    dense
    hide-details
    @focus="measureMenuWidth">
      <template #item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="d-flex align-center">
            <v-icon small left color="primary">mdi-pine-tree</v-icon>
            {{ item.name }}
          </v-list-item-title>
          <div
          v-if="showDescriptions && expandedDescriptionId === item.mitigationHabitatId"
          class="mt-1"
          style="white-space: normal;">
            <div class="dd-eyebrow">{{ $t('habitatDescription') }}</div>
            <div class="text-caption grey--text text--darken-2">{{ item.description || $t('noHabitatDescription') }}</div>
          </div>
        </v-list-item-content>
        <v-list-item-action v-if="showDescriptions" class="my-0">
          <v-btn icon small @click.stop="toggleDescription(item.mitigationHabitatId)">
            <v-icon color="info" small>{{ expandedDescriptionId === item.mitigationHabitatId ? 'mdi-information' : 'mdi-information-outline' }}</v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { menuWidthFromEvent } from '@/utils/menuWidth.js'

export default {
  name: 'HabitatAutocomplete',

  props: {
    value: {
      type: Array,
      required: true
    },
    habitats: {
      type: Array,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showDescriptions: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    expandedDescriptionId: null,
    menuWidth: undefined
  }),

  computed: {
    selectedIds: {
      get () {
        return this.value
      },
      set (ids) {
        this.$emit('input', ids)
      }
    },

    habitatsById () {
      return new Map(this.habitats.map(h => [h.mitigationHabitatId, h]))
    },

    displayIds () {
      return [...this.selectedIds].sort((a, b) => this.habitatName(a).localeCompare(this.habitatName(b)))
    }
  },

  methods: {
    measureMenuWidth (event) {
      this.menuWidth = menuWidthFromEvent(event)
    },

    filterHabitat (item, queryText, itemText) {
      return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    },

    toggleDescription (id) {
      this.expandedDescriptionId = this.expandedDescriptionId === id ? null : id
    },

    habitatName (id) {
      return this.habitatsById.get(id)?.name ?? ''
    }
  }
}
</script>

<style scoped>
/* avoids chips touching while retaining dense prop in v-autocomplete */
::v-deep .v-select__selections .v-chip {
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
